<script>
import {h, resolveComponent} from 'vue';

export default {
  name: 'nullWidget',
  props: {
    hover: null,
    minHeight: {
      type: Number,
      default: () => {
        return 206;
      }
    },
    iconSize: {
      type: Number,
      default: 37
    },
    fontSize: {
      type: Number,
      default: 14
    },
    errorMessage: {
      type: String,
      default: 'label.noData'
    }
  },
  render() {
    const legoIcon = resolveComponent('lego-icon');
    const cLabel = resolveComponent('c-label');
    return h(
        'div',
        {
          class: ['widget-null'],
          style: {
            display: 'table',
            minHeight: `${this.minHeight}px`,
            textAlign: 'center',
            width: '100%',
            height:'100%'
          }
        },
        [
          h('div', {class: [], style: [{display: 'table-cell'}, {verticalAlign: 'middle'}]}, [
            h(legoIcon, {
              iconType: 'picto',
              icon: 'widget_nodata',
              size: this.iconSize,
              color: '#737a8c'
            }),
            h(
                cLabel,
                {
                  size: this.fontSize,
                  weight: 400,
                  color: '#737a8c',
                  style: {
                    marginTop: '12px'
                  }
                },
                () => [this.$t(this.errorMessage)]
            )
          ])
        ]
    );
  }
};
</script>
